// modal-template-copy-referal.js
const classPrefix = 'modal-template-copy-referal';
const dataPrefix = 'data-modal-template-copy-referal';

export function modalTemplateCopyReferal($container, params = {}) {
    const $template = document.querySelector(`[${dataPrefix}-template]`);
    if (!$template) return;

    const $modalClone = document.importNode($template.content, true);

    // ищем внутри клонов
    const $clipboard = $modalClone.querySelector(`[${dataPrefix}-clipboard]`);
    const $clipboardCopy = $modalClone.querySelector(`[${dataPrefix}-clipboard-copy]`);

    // нормализация входных параметров:
    // могут быть переданы data-modal-referral -> dataset.modalReferral,
    // либо data-referral -> dataset.referral, либо params.referral напрямую
    const referral =
        params.referral ||
        params.modalReferral ||
        params.referralCode ||
        params.code ||
        '';

    if ($clipboard) {
        $clipboard.textContent = referral;
    }

    // функция для диспатча события + вызова callback, если он есть
    function notifyCopied(text) {
        // 1) если передан callback — вызываем его
        if (typeof params.onCopy === 'function') {
            try {
                params.onCopy(text);
            } catch (err) {
                console.error('onCopy callback error', err);
            }
        }
        // 2) всегда диспатчим глобальное событие — на него подписан основной модуль и покажет popup
        document.dispatchEvent(new CustomEvent('modal-template:notify', {detail: {text: 'Ссылка скопирована'}}));
    }

    // копирование в буфер
    async function doCopy(text) {
        if (!text) return;
        // Clipboard API
        if (navigator.clipboard && navigator.clipboard.writeText) {
            try {
                await navigator.clipboard.writeText(text);
                notifyCopied(text);
                return;
            } catch (err) {
                // fall through to fallback
            }
        }
        // fallback
        try {
            const ta = document.createElement('textarea');
            ta.value = text;
            // стили чтобы не влиял на UI
            ta.style.position = 'fixed';
            ta.style.left = '-9999px';
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
            notifyCopied(text);
        } catch (err) {
            console.error('Copy failed', err);
        }
    }

    if ($clipboardCopy) {
        $clipboardCopy.addEventListener('click', (e) => {
            e.preventDefault();
            doCopy($clipboard.textContent);
        });
    }

    $container.appendChild($modalClone);
}
